import styles from '../createPostModal/CreatePostModal.module.css'
import CreatePost from './createPostForm/CreatePostForm'

function CreatePostModal({ isVisible, handleSetCreatePost, onPostCreated }) {
	const closeModal = () => {
    handleSetCreatePost(false);
  };
	if (!isVisible) return null;

	return (
		<div className={styles.modalBackdrop}>
			<div className={styles.modalContent}>
				<div className={styles.postContent}>
					<CreatePost closeModal={closeModal} onPostCreated={onPostCreated} />
				</div>
				<button className={styles.closeButton} onClick={closeModal} aria-label="Fechar nova publicação">×</button>
			</div>
		</div>
	);
}

export default CreatePostModal
